<template>
  <base-dialog :show-close="true" :visible.sync="visible" class="add-group-dialog" width="520px">
    <template v-slot:header>{{ groupTypeMap[groupType] }}</template>
    <div class="main-content">
      <el-form :rules="rules" :model="form" label-width="100px" ref="form">
        <el-form-item prop="name" label="分组名称">
          <el-input placeholder="请输入分组名称" v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { groupTypeMap } from "@/views/Backend/Admin/Display/Menu/static"

export default {
  name: "AddGroupDialog",
  components: { BaseButton, BaseDialog },
  props: {
    groupType: String
  },
  data() {
    return {
      groupTypeMap,
      visible: false,
      form: {
        name: ""
      },
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }]
      }
    }
  },
  methods: {
    open() {
      this.form = this.$options.data().form
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit("submit", this.form)
          this.visible = false
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-group-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px 40px 0 40px;
      color: unset;
      display: flex;
      flex-flow: column;
      justify-content: center;
    }
  }
}
</style>
